import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { useTranslation } from 'react-i18next';

type TLangSwitcher = {
  type: 'app' | 'login';
};

function LanguageSwitcher({ type }: TLangSwitcher): JSX.Element {
  const { i18n } = useTranslation();
  i18n.language = localStorage.getItem('lng') || 'en';
  const language = i18n.language;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const transformLanguageToFlag = (language: string): string => {
    switch (language) {
      case 'en':
        return 'gb';
      case 'cs':
        return 'cz';
      /*ase 'fr':
        return 'fr';*/
      default:
        return 'gb';
    }
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageChange = (lang: string): void => {
    localStorage.setItem('lng', lang);
    void i18n.changeLanguage(lang);
    setAnchorEl(null);
  };

  return (
    <Box sx={type === 'app' ? { borderLeft: '1px solid #67bcff', pl: '20px' } : {}}>
      <IconButton
        aria-label="language-selector"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <span className={`fi fi-${transformLanguageToFlag(language)}`}></span>
      </IconButton>
      <Menu
        id="language-appBar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => handleLanguageChange('en')} disabled={language === 'en'}>
          English
        </MenuItem>
        <MenuItem onClick={() => handleLanguageChange('cs')} disabled={language === 'cs'}>
          Čeština
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default LanguageSwitcher;
